import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import HowItWorksSection from './components/HowItWorksSection';
import IndustriesSection from './components/IndustriesSection';
import ResultsSection from './components/ResultsSection';
import FinalCTASection from './components/FinalCTASection';
import Footer from './components/Footer';
import ContactModal from './components/ContactModal';

type ModalType = 'demo' | 'start';

export default function Home() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState<ModalType>('demo');

  const openModal = (type: ModalType) => {
    setModalType(type);
    setModalOpen(true);
  };

  return (
    <main className="bg-[#050505] font-sans" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>
      <Navbar onOpenModal={openModal} />
      <HeroSection onOpenModal={openModal} />
      <ProblemSection />
      <SolutionSection />
      <HowItWorksSection />
      <IndustriesSection />
      <ResultsSection />
      <FinalCTASection onOpenModal={openModal} />
      <Footer />
      <ContactModal
        isOpen={modalOpen}
        type={modalType}
        onClose={() => setModalOpen(false)}
      />
    </main>
  );
}
